import { handleActions } from 'redux-actions';

import { OrderAdditionalServicesFragment } from '@websky/graphql';
import { setAdditionalServices, SetAdditionalServicesAction } from './actions';

const initialState = {} as OrderAdditionalServicesFragment;

const additionalServicesReducer = handleActions(
	{
		[setAdditionalServices.toString()]: (_, { payload }: SetAdditionalServicesAction) => payload
	},
	initialState
);

export default additionalServicesReducer;
